import { useEffect, useRef, useState } from 'react';

const useTabChanger = (totalTabsNumber: number, timer: number) => {
  const [currentTab, setCurrentTab] = useState<number>(0);

  const timerRef: { current: null | ReturnType<typeof setTimeout> } =
    useRef(null);

  const handleChangeTab = () => {
    setCurrentTab(prevTabNumber =>
      prevTabNumber === totalTabsNumber - 1 ? 0 : prevTabNumber + 1,
    );
  };

  useEffect(() => {
    timerRef.current = setInterval(handleChangeTab, timer);

    return () => clearInterval(timerRef.current as NodeJS.Timeout);
  }, []);

  const resetTimer = (tabId: number) => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setCurrentTab(() => {
      timerRef.current = setInterval(handleChangeTab, timer);
      return tabId;
    });
  };

  return { currentTab, resetTimer };
};

export default useTabChanger;
